import type { CMSAccordionContainerDTO } from "~/CMSComponents/dto";
import { renderCMSComponent } from "~/CMSComponents/componentFactory";
import { AccordionGroup, AccordionGroupTitle } from "~/common/m3/Accordion/AccordionGroup";

interface Props extends Omit<CMSAccordionContainerDTO, "type"> {
  className?: string;
}

export const CMSAccordionContainer = (props: Props) => {
  return (
    <AccordionGroup>
      <AccordionGroupTitle>{props.title}</AccordionGroupTitle>
      {props.accordionItems.map((accordion, index) => {
        return renderCMSComponent(accordion, undefined, index);
      })}
    </AccordionGroup>
  );
};
